/* eslint-disable @typescript-eslint/no-explicit-any */
// Loose `any` on normalize() row input + response generics: BE field-shape is
// not codegen-derived (migration plan: "Loose types over generated codegen types").
import instance, { ADMIN_PREFIX } from 'services/api';
import {
  AdminLanguage,
  TranslatorPlan,
  TranslatorPlanInput,
  TranslatorPlanListQuery,
  TranslatorPlanListResponse
} from 'types/api/translatorPlans';

const normalizePlan = (row: any): TranslatorPlan => ({
  id: Number(row.id),
  name: row.name ?? '',
  description: row.description ?? null,
  lang_1: row.lang_1 ?? row.lang1 ?? '',
  lang_2: row.lang_2 ?? row.lang2 ?? '',
  duration: Number(row.duration ?? 0),
  price: Number(row.price ?? 0)
});

/**
 * GET /api/v2/admin/translator-plans — PaginatedResponse envelope on the
 * BE. FE consumers expect the legacy {results,total}; 0-based FE pages
 * shift to 1-based BE pages.
 */
export const fetchTranslatorPlans = async (
  query: TranslatorPlanListQuery
): Promise<TranslatorPlanListResponse> => {
  const params: Record<string, string | number> = {
    page: query.page ?? 1,
    limit: query.limit ?? 10
  };

  if (query.name) params.name = query.name;
  if (query.duration != null) params.duration = query.duration;

  const res = await instance.get<{ data: any[]; total: number }>(
    `${ADMIN_PREFIX}/translator-plans`,
    { params }
  );

  return {
    results: (res.data.data ?? []).map(normalizePlan),
    total: res.data.total ?? 0
  };
};

export const createTranslatorPlan = (input: TranslatorPlanInput) =>
  instance.post<TranslatorPlan>(`${ADMIN_PREFIX}/translator-plans`, input);

export const updateTranslatorPlan = (
  id: string | number,
  input: TranslatorPlanInput
) =>
  instance.put<TranslatorPlan>(`${ADMIN_PREFIX}/translator-plans/${id}`, input);

export const deleteTranslatorPlan = (id: string | number) =>
  instance.delete<{ status: boolean }>(
    `${ADMIN_PREFIX}/translator-plans/${id}`
  );

/**
 * DELETE /api/v2/admin/appointment-translators/:id — soft-delete the
 * translator request row. Used by the dashboard TranslatorRequests
 * Remove button (GET stays on Apollo gql/appointments until P24).
 */
export const deleteTranslatorRequest = (id: string | number) =>
  instance.delete(`${ADMIN_PREFIX}/appointment-translators/${id}`);

/**
 * GET /api/v2/admin/languages — system.languages list backing the
 * lang_1/lang_2 picker + the doctor profile language Select.
 */
export const fetchAdminLanguages = async (
  limit = 200
): Promise<AdminLanguage[]> => {
  const res = await instance.get<{ data: AdminLanguage[] }>(
    `${ADMIN_PREFIX}/languages`,
    { params: { page: 1, limit } }
  );

  return res.data.data ?? [];
};
